<template>
  <settings-element>
    <template #title>{{ title }}</template>
    <template #body>
      <Visibility v-bind="$attrs" />
    </template>
  </settings-element>
</template>

<script>
import SettingsElement from "@/components/campaign-builder/widget-settings/SettingsElement"
import Visibility from "@/components/campaign-builder/appearance-changers/Visibility"

export default {
  name: "SettingsVisibility",
  components: { Visibility, SettingsElement },
  props: {
    title: {
      type: String,
      default: "Visibility"
    }
  },
  inheritAttrs: false
}
</script>
